// eslint-disable-next-line
export default {
  name: "Michael Kelly",
  gravatar:
    "https://www.gravatar.com/avatar/a4c937a99c0bdf7e0b059cf13d380e1b.png?s=160",
  pdf: "Michael_Kelly_Resume.pdf",
  title: "Web Front End/Full Stack Developer",
  bio:
    "I am an Subject Matter Expert Software Engineer with over two decades of experience designing and building software in the intelligence community. I love to make web applications that are polished, standards based, and user friendly. While I prefer to work on the front end, my Computer Science background lends well when I need to get my hands dirty on the back end of systems. These skills have played a large part in the launches of 8 major web applications, four of them flagship level.",
  email: "michael.i.kelly@gmail.com",
  city: "Ashburn",
  state: "VA",
  phoneNumber: "(703)665-4110",
  clearance: "Active TS/SCI Clearance with Polygraph",
  education: "B.S, Computer Science, James Madison University (2002)",
  jobs: [
    {
      title: "SME Software Engineer",
      company: "ByteRatio",
      location: "Reston, VA",
      startYear: "2019",
      endYear: null,
      highlights: [
        "Led development of an AI-powered, multi-tenant talent management platform built with Next.js 16, TypeScript, and PostgreSQL, enabling organizations to intelligently match candidates to job postings. Architected a two-stage matching engine combining OpenAI vector embeddings with GPT-5 semantic reranking, backed by an event-driven ETL pipeline across 7 AWS Lambda functions for automated resume ingestion and profile extraction. Implemented organization-scoped data isolation, role-based access control, and Microsoft Azure AD authentication to support a secure, multi-organization SaaS architecture. (2025-present)",
        "Full Stack Developer on graph and data correlation web application using big data and developed with Vite and React for the front end. Developed Python Lambda functions and championed scalable asynchonous search features. Developed Playwright CI/CD integration using Kubernetes and Jenkins. (2024-2026)",
        "UI Developer Lead for next generation flagship web application for entitlement management using Next.js and React. Responsible for UX design, architecting CI/CD automation, and guiding team members in best practices. (2022-2024)",
        "Developer Lead for a web application providing search capabilities for a large datastore using Angular 11 and Elasticsearch. Responsible for mentoring junior team members and ensuring best practices are followed. (2021-2022)",
        "Front End Team Lead for a flagship web application delivering timely information for worldwide customers using Angular 8. Responsible for mentoring junior developers on the team in best practices. (2020-2021)",
        "UI Team Lead responsible for modernizing legacy Angular/Node password management application using React. Architected repeatable deploy process using Docker and AWS. (2019-2020)",
      ],
      skills: ["HTML", "CSS", "Next.js", "Vite", "React JS", "Angular 8,11", "NodeJS", "Jest", "Playwright", "Python", "TypeScript", "PostgreSQL", "Prisma", "OpenAI", "Git", "Docker", "Kubernetes", "AWS", "CDK","MCP", "RAG"],
    },
    {
      title: "Expert Software Engineer",
      company: "Excivity, Inc",
      location: "Chantilly, VA",
      startYear: "2017",
      endYear: "2019",
      highlights: [
        "Web UI Team Lead responsible for growing junior developers on team.",
        "Designed, Architected, and built Single Page Application (SPA) for User Communications (both text based and real-time voice with historical playback of each voice message), and User Management of system",
        "Architected and built SPA for management and interactive use (via VNC within a web page) of Android Mobile Device Emulators running in a cloud-based environment.",
        "Researched and developed automatic build pipeline using Docker and Gitlab for release management.",
      ],
      skills: [
        "HTML",
        "CSS",
        "React JS",
        "WebRTC",
        "JavaScript",
        "Photoshop",
        "Git",
        "Jira",
        "Docker",
        "GitLab",
      ],
    },
    {
      title: "Owner and Developer",
      company: "URL Droplet",
      location: "Ashburn, VA",
      startYear: "2011",
      endYear: "2018",
      highlights: [
        'Designed and developed web application for downloading files to a Dropbox account with just a URL. URL Droplet has been featured on <a href="http://lifehacker.com/5811317/url-droplet-downloads-files-from-a-web-address-straight-to-your-dropbox">Lifehacker</a><span class="no-print">(and <a href="http://lifehacker.com/5875743/how-to-use-your-smartphone-to-remotely-send-downloads-to-your-home-computer">here</a>)</span>, <a href="http://howto.cnet.com/8301-11310_39-20073094-285/4-killer-dropbox-tricks/">CNET</a>, and many other news sites and blogs around the world.',
      ],
      skills: [
        "Git",
        "Photoshop",
        "HTML",
        "CSS",
        "JQuery",
        "JavaScript",
        "Ruby on Rails",
        "MongoDB",
      ],
    },
    {
      title: "Senior Software Engineer",
      company: "GSM Consulting",
      location: "Reston, VA",
      startYear: "2012",
      endYear: "2017",
      highlights: [
        'Designed and developed a Ruby on Rails replacement for a Lotus Notes database. Transformed workflow to save 30+ man-hours/week.<span class="timeframe">2013-2017</span>',
        'User Interface Design Team Lead responsible for branding and design of user experience. Consultant on multiple projects at client location. <span class="timeframe">2012-2013</span>',
      ],
      skills: [
        "Ruby on Rails",
        "MySQL",
        "HTML",
        "CSS",
        "JQuery",
        "Ember",
        "React JS",
        "JavaScript",
        "Photoshop",
        "Git",
      ],
    },
    {
      title: "Senior Software Engineer",
      company: "NCI Inc",
      location: "Reston, VA",
      startYear: "2008",
      endYear: "2012",
      highlights: [
        `Lead Designer and Lead Developer for senior policy leadership's flagship publication web application using HTML/CSS/JS (JQuery) and Ruby on Rails. <span class="timeframe">2011-2012</span>`,
        'User Experience Designer for new search capability on flagship publication web application. Conducted User interviews, created prototypes and developed beta implementation. <span class="timeframe">2011</span>',
        'Lead Designer and Developer for a streaming video web application using HTML/CSS/JS (Prototype) and Ruby on Rails. <span class="timeframe">2010</span>',
        `Co-designed, and implemented a complete rebranding of client's flagship publication web application using HTML/CSS/JS (Prototype) and Ruby on Rails. <span class="timeframe">2009</span>`,
        'Developer for a publication web application using HTML/CSS/JS (Prototype) and Ruby on Rails. Responsible for designing admin tools and pages on the site using extensive use of AJAX. <span class="timeframe">2008</span>',
      ],
      skills: [
        "Ruby on Rails",
        "HTML",
        "CSS",
        "JQuery",
        "Prototype",
        "Backbone",
        "JavaScript",
        "Photoshop",
        "Oracle",
        "Git",
      ],
    },
    {
      title: "Lead Software Engineer",
      company: "SpecTal Consultants",
      location: "Reston, VA",
      startYear: "2006",
      endYear: "2007",
      highlights: [
        `
          Led and managed software development team that included
          three separate subcontractors designing and building a
          multi-modal biometric software system.`,
        `
          Responsible for planning the development schedule as well as
          keeping the team on schedule and on budget.
        `,
      ],
      skills: [
        `Microsoft Project`,
        `Java`,
        `J2EE`,
        `HTML`,
        `CSS`,
        `Subversion`,
      ],
    },
    {
      title: "Senior Software Engineer",
      company: "L-3 Communications Titan Group",
      location: "Reston, VA",
      startYear: "2005",
      endYear: "2006",
      highlights: [
        `
          Led the User Interface team for a large scale Internet
          exploitation tool working on designs for the Graphical User
          Interface and integrated vendor components.
        `,
        `
          Designed and developed a Java Eclipse Plug-in for search
          within a knowledge management tool.
        `,
        `
          Designed and developed Java infrastructure applications to
          integrate a message feed into the overall architecture.
        `,
      ],
      skills: [`Java`],
    },
    {
      title: "Senior Software Engineer",
      company: "L-3 Communications Titan Group",
      location: "Reston, VA",
      startYear: "2004",
      endYear: "2005",
      highlights: [
        `Gathered customer requirements from the customer.`,
        `
          Designed and developed a business workflow processing system
          using Tibco.
        `,
        `
          Designed and developed Java remote execution and status
          display applications using JMS.
        `,
      ],
      skills: [`Java`, `JMS`, `Tibco`],
    },
    {
      title: "Software Engineer",
      company: "L-3 Communications Titan Group",
      location: "Reston, VA",
      startYear: "2002",
      endYear: "2004",
      highlights: [
        `Developed subsystems for XML message processing and
        correlation using C++ and Java.`,
      ],
      skills: [`C++`, `Java`, `XML`, `CVS`, `CMMI Level 3`],
    },
    {
      title: "Intern",
      company: "Integrity Applications Inc",
      location: "Chantilly, VA",
      startYear: "2001",
      endYear: "2001",
      highlights: [
        `Implemented a browser-based graphical analysis subsystem
        driven by XML data using JavaScript, VBScript, XSL, and
        HTML.`,
      ],
      skills: [`HTML`, `CSS`, `JavaScript`, `VBScript`, `XML`, `XSL`],
    },
    {
      title: "Intern",
      company: "Fairfax Imaging, Inc",
      location: "Chantilly, VA",
      startYear: "2000",
      endYear: "2001",
      highlights: [
        `Designed and implemented a graphical interface on top of an
        existing legacy application using C++ and MFC.`,
      ],
      skills: [`C++`, `MFC`],
    },
  ],
};
